import React from "react";
import { Link } from "react-navi";
import styles from "./BlogFooter.module.css";

function BlogFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.links}>
          <Link href="/about">About</Link>
          <Link href="/tags">Tags</Link>
          <a href="/rss.xml" target="_blank" rel="noopener noreferrer">
            RSS
          </a>
          <a
            href="https://imagetext.xyz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            OCR Tools
          </a>
        </div>
        <p className={styles.copyright}>
          &copy; {year}{" "}
          <a
            href="https://imagetext.xyz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            imagetext.xyz
          </a>
          . Free OCR for everyone.
        </p>
      </div>
    </footer>
  );
}

export default BlogFooter;
